const languageData = [
  {
    languageId: 'lao',
    locale: 'la',
    name: 'ພາສາລາວ',
    icon: 'la',
  },
  {
    languageId: 'vietnam',
    locale: 'vi',
    name: 'Tiếng Việt',
    icon: 'vn',
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
];
export default languageData;
